import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';

interface UpdateKnownDomainsRequest {
  knownDomains: string[];
}

interface UpdateKnownDomainsResponse {
  knownDomains: string[];
}

export function useUpdateKnownDomains() {
  const queryClient = useQueryClient();

  return useMutationApi<
    UpdateKnownDomainsRequest,
    UpdateKnownDomainsResponse,
    UpdateKnownDomainsResponse
  >({
    endpoint: 'organization/known-domains',
    method: 'POST',
    successMessage: 'Known domains updated successfully',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['organization/known-domains'],
        });
      },
    },
  });
}
